import React from 'react';
import '../../estilos/miActividad/miActividad.css'
import NoContentPage from '../noContent/noContentPage'


const Audiolibros = () => {
    return (
        <div className="pagina-inicio">
            
            <div className="content">
            <NoContentPage/>
            </div>
        </div>
    );
};

export default Audiolibros;
